import { render, staticRenderFns } from "./todo_button.vue?vue&type=template&id=47b2edfa"
import script from "./todo_button.vue?vue&type=script&lang=js"
export * from "./todo_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports